import { axiosWithToken } from "@/utils/axios";
import parseHttpError from "@/utils/parseHttpError";
// import { EditPropertyPayload } from "@/types/admin";
import { EditPropertyPayload } from "@/types/property";

export interface EditOwnPropertyPayload extends EditPropertyPayload {}

export interface EditOwnPropertyResponse {
  success: boolean;
  message?: string;
  statusReset?: boolean;
  error?: string;
  errorCode?: string;
  data?: any;
}

class UserPropertyEditService {
  async editOwnProperty(
    data: EditOwnPropertyPayload,
  ): Promise<EditOwnPropertyResponse> {
    if (!data.id) {
      return { success: false, error: "Property ID is required" };
    }

    const payload: Record<string, any> = {
      ...data,
    };

    Object.keys(payload).forEach((key) => {
      if (payload[key] === undefined || payload[key] === null) {
        delete payload[key];
      }
    });

    try {
      const response = await axiosWithToken().patch(
        `/properties/${data.id}/edit`,
        payload,
      );
      return {
        success: true,
        message: response.data?.message || "Property updated successfully",
        statusReset: !!response.data?.statusReset,
        data: response.data?.data,
      };
    } catch (error: any) {
      const message: string = parseHttpError(error).message;
      return {
        success: false,
        error: message,
        errorCode:
          message === "REAPPROVAL_REQUIRED" ? "REAPPROVAL_REQUIRED" : undefined,
      };
    }
  }
}

const userPropertyEditService = new UserPropertyEditService();
export default userPropertyEditService;
